"use client"

import ClickableLink from "../utilities/ClickableLink";
import {Suspense, use} from "react";
import moment from "moment/moment";
import {IFallbackData} from "../../utils/SchoolBlocksUtilities";
import styles from "./styles/RightColumnWidget.module.scss"
import classNames from "classnames";
import ImageComponent from "../utilities/ImageComponent";
import NewsImage from "../../assets/images/news.png";
import {withLocaleInURI} from "../../internationalization/i18nURI";
import {useStores} from "../../stores/useStores";
import {SchoolFeedMobileWidgetLink} from "./SchoolFeedMobileWidgetLink";
import {useSchoolFeedUrlQuery} from "../../hooks/useSchoolFeedData";

function useNewsUrl() {
    const {i18nStore} = useStores();
    const urlQuery = useSchoolFeedUrlQuery()

    return {
        pathname: withLocaleInURI("/feed", i18nStore.currentAppSupportedLocale),
        query: {...urlQuery, type: "news", currentView: "content"}
    }
}

export function MobileNewsWidgetLink(props: {
    active: boolean;
}) {
    const href = useNewsUrl();

    return <SchoolFeedMobileWidgetLink
        href={href}
        active={props.active}
        src={NewsImage}
        text={"News"}
    />
}

export function NewsWidget(props) {
    const href = useNewsUrl();

    return <ClickableLink href={href} className={classNames(styles.upcomingNews, styles.widget)}>
        Explore Recent News
    </ClickableLink>
}
